import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import { queryKeys } from './queryKeys';

export function useSpendingSummary() {
  const { authFetch } = useAuthContext();

  return useQuery({
    queryKey: queryKeys.user.spending,
    queryFn: async () => {
      const response = await authFetch('/api/users/spending-summary');
      if (!response.ok) throw new Error('Failed to load spending summary');
      return response.json();
    },
  });
}

export function useUserPreferences() {
  const { authFetch } = useAuthContext();

  return useQuery({
    queryKey: queryKeys.user.settings,
    queryFn: async () => {
      const response = await authFetch('/api/users/update-preferences');
      if (!response.ok) throw new Error('Failed to load user preferences');
      return response.json();
    },
  });
}
